import React from 'react'
import { Box } from '@mui/material'
import { SourceTreeManagement, DoTheAction } from './SourceTreeManagement'
import { useMoveNode } from '../TreeActions'
import { useAtom, useAtomValue } from 'infrastructure/state/jotai.wrapper'
import {
  copySourceNodeAtom,
  selectedDestinationSiblingNodeAtom,
  selectedNodeAtom,
  workingTreeAtom,
} from './atoms'

// This component is responsible for setting up and performing the Move action
export function MoveNode() {
  const { resetTree } = useAtomValue(workingTreeAtom)
  const [sourceNode, setSourceNode] = useAtom(copySourceNodeAtom)
  const destParent = useAtomValue(selectedNodeAtom)
  const siblingNode = useAtomValue(selectedDestinationSiblingNodeAtom)

  const moveAction = useMoveNode()

  const actionDisabled = !sourceNode || (!destParent && !siblingNode)
  const doIt = async () => {
    if (actionDisabled) return
    await moveAction({ sourceNode, siblingNode })
    setSourceNode(undefined)
    resetTree?.()
  }

  const isReorder =
    sourceNode?.parent_id === destParent?.id &&
    sourceNode?.parent_id === siblingNode?.parent_id
  return (
    <Box>
      <DoTheAction
        action={doIt}
        actionName={'Move'}
        disabled={actionDisabled}
      />
      {isReorder && <Box padding="10px">This is reordering the nodes.</Box>}
      <SourceTreeManagement onlySameSource={true} action={'Move'} />
    </Box>
  )
}
